<template>
  <div>
    <create-card route_back="ShippingRates" model_name="frete" :saving="loading.saving" :loading="loading.initial">
      <template slot="form">
        <shipping-rate-form
          ref="form"
          :shipping_rate="shipping_rate"
          :pickup_locations="pickup_locations"
          :regions="regions"
        />
        <div class="d-flex justify-end">
          <f-btn save @click="createShippingRate" />
        </div>
      </template>
    </create-card>
  </div>
</template>

<script>
import Api from "@/api/index"
import { flattenRegionsForSelect } from "@/_backoffice/_registrations/components/region/flattenRegionsTree.js"
import shippingRateNotificationMixin from "./shippingRateNotificationMixin.js"

export default {
  name: "CreateShippingRate",
  mixins: [shippingRateNotificationMixin],
  components: {
    CreateCard: () => import("@/_backoffice/_registrations/components/shared/create/CreateCard.vue"),
    ShippingRateForm: () => import("@/_backoffice/_registrations/components/shipping_rates/forms/ShippingRateForm.vue"),
  },
  data() {
    return {
      loading: {
        initial: false,
        saving: false,
      },
      shipping_rate: {
        pickup_location_id: null,
        region_id: null,
        kilometers: 0,
        unit_price: 0,
        discharge_price: 0,
      },
      pickup_locations: [],
      regions: [],
    }
  },
  methods: {
    getData() {
      this.loading.initial = true
      this.getPickupLocations()
      this.getRegions()
      this.loading.initial = false
    },
    getPickupLocations() {
      Api.PickupLocation.index({ index_serializer: true }).then((res) => {
        this.pickup_locations = res?.data?.data || []
      }).catch(() => {
        this.pickup_locations = []
      })
    },
    getRegions() {
      Api.Region.index().then((res) => {
        this.regions = flattenRegionsForSelect(res.data).filter((region) => region.kind === "city")
      }).catch(() => {
        this.regions = []
      })
    },
    parseMoney(value) {
      let normalized = String(value == null ? "" : value).replace(/\./g, "").replace(",", ".")
      let parsed = Number(normalized)
      return Number.isFinite(parsed) ? parsed : 0
    },
    createShippingRate() {
      if (!this.$refs.form.validate()) return
      this.loading.saving = true
      let payload = {
        pickup_location_id: this.shipping_rate.pickup_location_id,
        region_id: this.shipping_rate.region_id,
        kilometers: Number(this.shipping_rate.kilometers || 0),
        unit_price: this.parseMoney(this.shipping_rate.unit_price),
        discharge_price: this.parseMoney(this.shipping_rate.discharge_price),
      }
      Api.ShippingRate.create(payload).then(() => {
        this.successSaved()
        this.$router.push({ name: "ShippingRates" })
      }).catch((error) => {
        let msg = this.shippingRateApiUserMessage(error, "Erro ao criar o frete.")
        this.addNotification({ type: "error", msg })
      }).finally(() => {
        this.loading.saving = false
      })
    },
  },
  mounted() {
    this.getData()
  },
}
</script>
